import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';

// 查询可编辑信息---api
export const userOneselfInfo = data => http.Axios.post(rootPath + '/api/user/oneself/info', data);
// 可用积分和将过期积分---api
export const userPointInfo = data => http.Axios.post(rootPath + '/api/userPoint/info', data);
// 用户积分明细列表---api
export const userPointRecordpage = data => http.Axios.post(rootPath + '/api/userPointRecord/page', data);
// 编辑个人信息---api
export const userUpdateOneself = data => http.Axios.post(rootPath + '/api/user/update/oneself', data);
// 手机号校验---api
export const userUpdateCheckPhone = data => http.Axios.post(rootPath + '/api/user/update/checkPhone', data);
//编辑个人头像---api
export const userUpdateLogo = data => http.Axios.post(rootPath + '/api/userSafetyInfo/update/logo', data);
//安全中心发送手机短信
export const userSafetyInfosendsmsCode = data => http.Axios.post(rootPath + '/api/userSafetyInfo/send/smsCode', data);
// 安全中心手机号认证
export const userSafetyInfoverifyphone = data => http.Axios.post(rootPath + '/api/userSafetyInfo/verify/phone', data);
// 安全中心实人认证
export const userSafetyInfoverifyface = data => http.Axios.post(rootPath + '/api/userSafetyInfo/verify/face', data);
//安全中心修改登陆密码
export const userSafetyInfoupdatepassword = data =>
  http.Axios.post(rootPath + '/api/userSafetyInfo/update/password', data);
// 安全中心修改支付密码
export const userSafetyInfoupdatepayment = data =>
  http.Axios.post(rootPath + '/api/userSafetyInfo/update/payment', data);
// 全部设为已读
export const msgCentersetAllRead = data => http.Axios.post(rootPath + '/api/msgCenter/setAllRead', data);
//个人消息分页查询
export const msgCenterpage = data => http.Axios.post(rootPath + '/api/msgCenter/page', data);
//获取人脸识别结果
export const verifygetResult = data => http.Axios.post(rootPath + '/api/userSafetyInfo/verify/getResult', data);
//消息详情
export const msgCenterdetail = data => http.Axios.post(rootPath + '/api/msgCenter/detail', data);
//系统消息已读
export const msgCentersetSingleRead = data => http.Axios.post(rootPath + '/api/msgCenter/setSingleRead', data);
//我的订单
export const welfaregetMyOrderPageByUserId = data =>
  http.Axios.post(rootPath + '/api/welfare/getMyOrderPageByUserId', data);
//互联网订单详情
export const internetorderDetail = data => http.Axios.post(rootPath + '/api/internetorder/detail', data);
//订单详情
export const welfaregetWelfareOrderDetail = data =>
  http.Axios.post(rootPath + '/api/welfare/getWelfareOrderDetail', data);
//订单取消接口
export const welfarecancelOrder = data => http.Axios.post(rootPath + '/api/welfare/cancelOrder', data);
//订单退款接口
export const welfarerefundOrder = data => http.Axios.post(rootPath + '/api/welfare/refundOrder', data);
//继续支付订单
export const welfareContinuePayOrder = (data, responseType) =>
  http.Axios.post(rootPath + '/api/welfare/continuePayOrder', data, { responseType });
// 获取继续支付信息
export const GetContinuePayInfo = data => http.Axios.post(rootPath + '/api/welfare/getContinuePayInfo', data);
//我的权益
export const queryMyEquity = data => http.Axios.post(rootPath + '/api/noauth/healthManage/queryMyEquity', data);

/* ----------------
    V1.7我的订单
---------------- */
// 订单详情
export const OnlineProductOrderDetails = data => http.Axios.post(rootPath + '/api/onlineProductOrder/detail', data);
// 互联网订单分页查询
export const OnlineProductOrderPage = data => http.Axios.post(rootPath + '/api/onlineProductOrder/page', data);

export const healthServicePlatformgoToUse=data=>http.Axios.post(rootPath+'/api/noauth/healthServicePlatform/goToUse',data)


